export function formatMoney(cents, currency = 'CAD') {
  const amount = Number(cents || 0) / 100;
  try {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: String(currency || 'CAD').toUpperCase(),
      maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${String(currency || 'CAD').toUpperCase()}`;
  }
}
